import { render, staticRenderFns } from "./Commentary.vue?vue&type=template&id=ca133cd6&"
import script from "./Commentary.vue?vue&type=script&lang=js&"
export * from "./Commentary.vue?vue&type=script&lang=js&"
import style0 from "./Commentary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports